// CSS
import '_Asset/css/User/Page/addition.css';

// Component
import dompurify from "dompurify";


const TOS = () => {

  const sanitizer = dompurify.sanitize;

  return (
    <>
      {/* Visual */}
      <div className="visual addition center">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">서비스 이용약관</h2>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="additionArea areaBox">
            <pre dangerouslySetInnerHTML={{ __html: sanitizer(`
<h2>제1조 목적</h2>이 약관은 (주)페이게이트(이하 “페이게이트”라 합니다)가 웹 서비스, 모바일 애플리케이션, 기타 응용 프로그램(이하 “프로그램 등”이라고 합니다)을 개발하는데 필요한 플랫폼과 페이게이트의 다양한 서비스와 연계할 수 있는 부가적인 기능을 제공하는 웹사이트(https://developers.seyfert.co.kr, 이하 “개발자 웹사이트”라 합니다)를 회원이 이용하기 위한 조건 및 절차에 관한 사항과 기타 필요한 사항을 규정함을 목적으로 합니다.

<h2>제2조 정의</h2>① “서비스”라 함은 플랫폼API, 서비스API 등 회원의 프로그램 등 개발 지원을 위해 페이게이트가 개발자 웹사이트를 통해서 제공하는 모든 서비스를 말합니다.
② “회원”이라 함은 페이게이트 또는 seyfert 회원사 계정을 갖고 있는 자 중에서 이 약관에 따라 페이게이트와 이용계약을 체결하고, 개발자 웹사이트를 통해 프로그램 등을 개발하는 자를 말합니다.
③ “API”라 함은 Application Programming Interface의 약자로서 회원의 애플리케이션 등에서 페이게이트가 제공하는 기술을 사용하기 위한 인터페이스를 의미합니다.
④ “애플리케이션”이라 함은 회원이 API를 적용시키고자 하는 회원의 애플리케이션, 프로그램 또는 웹사이트 등을 총괄하여 의미합니다.
⑤ “비즈 앱”이란 사업자 정보가 등록된 애플리케이션을 의미합니다.

<h2>제3조 약관의 게시와 개정</h2>① 페이게이트는 이 약관의 내용을 회원이 쉽게 알 수 있도록 개발자 웹사이트 초기 화면에 게시합니다.
② 페이게이트는 약관의규제에관한법률 등 관련법을 위반하지 않는 범위에서 이 약관을 변경할 수 있습니다.
③ 페이게이트가 약관을 변경할 경우에는 적용일자 및 개정사유를 명시하여 개발자 웹사이트에서 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 내용으로 개정되는 경우 적용일자 30일 전에 제9조 제1항에서 정한 통지 수단으로 개별 통지합니다.
④ 페이게이트가 전항에 따라 변경 약관을 공지 또는 통지하면서 회원에게 일정 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 변경 약관에 동의한 것으로 봅니다.
⑤ 회원이 변경 약관의 적용에 동의하지 않는 경우 페이게이트는 변경 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우 페이게이트는 이용계약을 해지할 수 있습니다.

<h2>제4조 약관의 해석</h2>① 페이게이트는 서비스 제공과 관련하여 별도의 서비스 운영정책(이하 “운영정책”이라 합니다)을 둘 수 있습니다.
② 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 운영정책 및 관계법령 또는 상관례에 따릅니다.

<h2>제5조 서비스 회원 가입의 성립</h2>① 서비스 회원의 가입은 회원이 되고자 하는 자(이하 “가입신청자”라고 합니다)가 약관의 내용에 대하여 동의를 한 다음 페이게이트가 정한 절차에 따라 회원가입신청을 하고, 페이게이트가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
② 페이게이트는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 페이게이트는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
 
1.   가입신청자가 이 약관의 의하여 이전에 회원자격을 상실한 적이 있는 경우. 다만, 페이게이트의 회원 재가입 승낙을 얻은 경우에는 예외로 함.
2.   실명이 아니거나 타인의 명의를 이용한 경우
3.   허위의 정보를 기재하거나, 페이게이트가 제시하는 내용을 기재하지 않은 경우
4.   14세 미만 가입신청자의 법정대리인 동의가 없는 경우
5.   가입신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우

③ 페이게이트는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.

<h2>제6조 회원정보의 변경</h2>① 회원은 개발자 웹사이트를 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.
② 회원은 회원가입신청시 기재한 사항이 변경되었을 경우 개발자 웹사이트를 통하여 수정을 하거나 전자우편 기타 방법으로 페이게이트에 대하여 그 변경사항을 알려야 합니다.
③ 전항의 변경사항을 페이게이트에 알리지 않아 발생한 불이익에 대하여 페이게이트는 책임을 부담하지 않습니다.

<h2>제7조 개인정보보호 의무</h2>페이게이트는 개인정보 보호법 등 관련 법령에서 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 개인정보처리방침이 적용됩니다.

<h2>제8조 회원의 계정 관리에 대한 의무</h2>① 회원의 개발자 웹사이트 계정에 대한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안됩니다.
② 회원은 계정이 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 페이게이트에 통지하고 페이게이트의 안내에 따라야 합니다.
③ 전항의 경우에 해당 회원이 페이게이트에 그 사실을 통지하지 않거나, 통지한 경우에도 페이게이트의 안내에 따르지 않아 발생한 불이익에 대하여 페이게이트는 책임을 부담하지 않습니다.

<h2>제9조 회원에 대한 통지</h2>① 회원에 대한 통지를 하는 경우 페이게이트는 회원이 등록한 전자우편 주소 또는 SMS, 페이게이트톡 메시지 등으로 할 수 있습니다.
② 페이게이트는 회원의 연락처 미기재, 변경 등으로 인하여 개별 통지가 어렵거나 불특정 다수 회원에 대한 통지를 하는 경우 개발자 웹사이트 게시판 등에 게시함으로써 개별 통지에 갈음할 수 있습니다.

<h2>제10조 페이게이트의 권리, 의무</h2>① 페이게이트는 관련 법령과 이 약관을 준수하며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
② 페이게이트는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위하여 보안시스템을 갖추어야 하며, 개인정보처리방침을 공시하고 준수합니다.
③ 페이게이트는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정될 경우 이를 처리하여야 하며, 개발자 웹사이트 내 게시판, 전자우편 등을 통하여 회원에게 처리과정 및 결과를 전달할 수 있습니다.
④ 페이게이트는 회원의 서비스 이용 사실을 소개하기 위한 목적으로 회원의 이름, 로고, 콘텐츠를 별도의 비용 없이 게시할 수 있습니다. 단, 회원의 요청 시 상호 협의 하에 게시를 중단하거나 수정하여 재게재할 수 있습니다.

<h2>제11조 회원의 의무</h2>① 회원은 관계법령, 이 약관, 운영정책, 이용안내, 기술 설명서, 개발 가이드 및 페이게이트가 공지하거나 통지한 사항 등을 준수하여야 하며, 기타 페이게이트의 업무에 방해되는 행위를 하여서는 안 됩니다.
② 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 아니되며, 다음 각 호의 행위를 하는 경우 페이게이트는 사전통보 없이 해당 회원의 서비스 이용을 중지하거나 이용계약을 해지할 수 있습니다.

1.    다른 회원 및 제3자의 페이게이트 계정을 부정사용 하는 행위
2.    범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위
3.    타인(페이게이트 포함)의 지적재산권 등의 권리를 침해하는 행위
4.    해킹행위 또는 컴퓨터바이러스 등의 유포행위
5.    페이게이트가 안내하는 방법 이외의 다른 방법을 사용하여 서비스에 접근하는 행위
6.    페이게이트의 이용자 정보를 무단으로 수집, 이용하거나 다른 사람에게 제공하는 행위
7.    서비스를 이용하여 관계 법령에 위반하여 영리목적의 광고성 정보를 발송하는 행위
8.    음란 및 저작권 침해 등 법령을 위반하는 내용의 프로그램 등을 개발하는 행위
9.    페이게이트가 제공하는 모든 서비스 또는 이에 포함된소프트웨어의 일부를 복사, 수정, 배포, 판매, 양도, 대여, 담보제공하거나, 타인에게 그 이용을 허락하는 행위와 소프트웨어를 역설계하거나 소스 코드의 추출을 시도하는 등의 행위
10.   페이게이트의 명시적인 동의 없이 페이게이트의 상표 및 로고 등의 영업표지를 무단으로 사용하는 행위
11.   서비스 이용을 위해 요구되는 파라미터 즉, 개발자 계정의 프로필(이름, 이메일 주소 등), 애플리케이션/서비스의 정보(서비스명, 아이콘, 사이트 도메인, 패키지명, 마켓 URL, 번들ID 등) 등을 허위로 입력하거나 다르게 기재하는 행위(정보가 변경되었음에도 수정하지 않고 과거의 정보를 그대로 유지하거나, 단축 도메인 등록 후 부정한 목적으로 해당 단축 도메인의 링크를 변경하여 사용하는 경우 및 이와 유사한 경우를 포함)
12.   페이게이트스토리 자동 포스팅 등과 같이 사용자의 동의 없이 사용자를 대신하여 콘텐츠를 게시하는 행위
13.   개인정보보호법 제20조(정보주체 이외로부터 수집한 개인정보의 수집 출처 등 고지), 제30조(개인정보 처리방침의 수립 및 공개) 등 페이게이트 또는 서비스를 통해 제공/처리위탁 되거나 자체적으로 수집한 이용자 개인정보의 이용, 제3자 제공, 처리 위탁 등에 있어 준수해야할 법규를 위반하는 행위
14.   이용자를 페이게이트톡, 페이게이트스토리 등 페이게이트가 운영하는 서비스로부터 그 외부로 리디렉션하는 것을 주목적으로 하여 서비스를 이용하는 행위
15.   페이게이트의 사전 승인을 얻지 아니하고 언론 매체나 이용자에게 페이게이트와의 관계에 관하여 언급(공식 보도 자료 작성, 웹 게시글 공개 등 포함)하는 행위
16.   서비스 이용이 제한되는 카테고리에 해당되는 애플리케이션, 웹에 활용하기 위하여 서비스를 이용하는 행위(서비스 이용이 제한되는 카테고리는 운영정책에서 정합니다)
17.   인종 또는 민족 차별을 옹호하는 내용 등 특정 내용을 표시/처리하는 애플리케이션, 웹에서 본 서비스를 이용하는 행위(구체적인 사항은 운영정책에서 정합니다)
18.   제공 한도를 초과하여 서비스를 이용하는 행위(구체적인 일일 제공량 한도, 월간 제공량 한도, MAU 한도 등은 운영정책에서 정하며, 추후 변경될 수 있습니다)
19.   서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위
20.   페이게이트가 제공하는 서비스와 무관한 사유로 회원이 운영하는 서비스에서 에러가 발생하였음에도 언론 매체 또는 이용자에게 그 에러가 페이게이트의 책임으로 발생했다고 알리는 행위
21.   서비스를 이용하여 페이게이트의 서비스 또는 회원의 서비스의 이용자에게 불편 및 피해를 끼치는 행위(서비스를 통해 연결된 회원의 서비스에서 발생하는 경우를 포함합니다)
22.   운영정책 제2조를 위반하는 행위
23.   그 외 운영정책에서 명시된 금지 행위(구체적인 사항은 운영정책에서 정합니다)

③ 회원은 서비스 및 개발자센터를 이용하여 얻은 정보(데이터, 비밀 키, 엑세스 토큰 등 포함)를 페이게이트의 사전 승낙 없이, 복사, 복제, 변경, 번역, 출판, 방송, 검색 엔진 또는 디렉터리에 입력 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다. 단, 대리인과 기밀 유지 계약을 체결한 경우에는 해당 정보를 공유할 수 있습니다.
④ 회원은 서비스 제공 또는 이 약관 위반을 확인하기 위해 페이게이트가 자료 또는 접근권한의 제공 및 관련사실에 대한 소명을 요청하는 경우에는 이에 성실히 임하여야 합니다.
⑤ 회원은 소프트웨어개발키트(SDK)를 비롯하여 서비스를 통해 페이게이트가 제공하는 기능에 대한 버전 업데이트를 수시로 확인하여야 합니다.
⑥ 회원은 회원이 운영하는 프로그램 등에서의 개인정보 보호와 관련하여 다음 각 호의 사항을 모두 준수하여야 합니다. 만약 본 항의 의무를 위반한 것을 페이게이트가 인지하게 되는 경우 페이게이트는 해당 회원의 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
개발자 웹사이트 설정 페이지 내 회원의 프로그램 등 동의 항목 관리 화면에서 회원의 프로그램 등 실제 서비스 내용과 일치하도록 항목 입력
페이게이트에서 제공하는 개인정보를 송수신 시 암호화 처리
회원이 운영하는 프로그램의 가입을 위하여 가입여부를 확인하는 등 페이게이트가 제공하는 이용자의 개인정보를 이용하는 경우, 이용자가 최종 가입하지 않거나 24시간 내에 가입하지 않는 경우 이용자의 모든 개인정보 파기
회원의 프로그램 등 내 이용자 탈퇴 메뉴를 제공하고 이용자 탈퇴 시 이용자의 모든 개인정보 파기
기타 개인정보 보호법등 개인정보의 보호과 관련된 법령상 회원의 의무사항을 성실히 준수
⑦ 사용자 데이터를 수집/분석할 수 있는 기술 또는 API를 사용하는 과정에서 회원이 페이게이트에게 서비스 이용자의 데이터를 제공한 경우, 회원은 개인정보 보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관계 법령, 유관 기관의 지침, 가이드라인 등을 준수해야 합니다.
⑧ 제7항의 데이터가 개인정보에 해당할 경우, 회원은 개인정보 보호법에 따라 회원의 이용자로부터 개인정보 제3자 제공 동의를 받아야 합니다.
⑨ 회원이 본 조에서 정하는 의무 사항을 위반한 결과 페이게이트에 손해가 발생하는 경우 페이게이트는 회원에 대하여 손해배상을 청구할 수 있습니다.

<h2>제12조 서비스의 내용</h2>① 서비스는 다음 각 호와 같이 구분합니다.
1.   플랫폼API : 페이게이트 플랫폼의 사용자 관리 기능을 시작으로 푸시 알림, 앱로그 분석, 스토리지 서비스 등 다양한 기반 플랫폼을 제공하는 서비스입니다.
2.   서비스API : 페이게이트가 제공하는 개별 서비스에서 회원이 활용 가능한 API를 제공하는 서비스입니다.

② 회원은 애플리케이션 생성 후 사업자 정보를 등록함으로써 비즈 앱 권한을 획득할 수 있으며, 서비스에서 제공하는 API 중 비즈니스와 연결이 필요한 기능을 이용하기 위해서는 ‘페이게이트비즈니스’ 이용약관에 대해 동의하고 해당 서비스에 가입하여야 합니다. 비즈니스와 연결이 필요한 기능의 종류 및 내용은 운영정책에서 정한 바에 따릅니다.
③ 페이게이트는 서비스의 이용 신청 절차 및 이용방법, 기타 서비스의 상세 내용 등을 개발자 웹사이트를 통해 안내할 수 있으며, 회원은 서비스 이용 전에 이를 신중히 확인하여야 합니다.

<h2>제13조 서비스의 제공 등</h2>① 페이게이트가 제공하는 서비스는 회원의 자격과 애플리케이션의 상태에 따라 차등 제공될 수 있습니다.
② 회원은 회사가 유료서비스를 제공하는 경우 유료이용약관에 동의 후 유료 서비스를 이용할 수 있습니다. 유료에 따른 상세한 서비스 내용은 유료이용약관 및 개발자 웹사이트 내 유료정책 설명 페이지를 통해 확인할 수 있습니다.
③ 서비스의 이용은 페이게이트의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.
④ 페이게이트는 컴퓨터 등 정보통신설비의 보수점검, 교체, 고장, 장애, 통신두절 또는 운영상 합리적인 사유가 있는 경우 서비스 제공을 일시적으로 중단할 수 있습니다. 이 경우 페이게이트는 제9조에 정한 방법으로 회원에게 통지합니다. 다만, 페이게이트가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
⑤ 페이게이트는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 개발자 웹사이트를 통해 공지한 바에 따릅니다.
⑥ 페이게이트는 프로그램 등의 요청에 따라 페이게이트가 제공하는 정보가 전송되는 경우 광고 또는 광고로 연결되는 페이지 등 페이게이트가 정하는 정보를 함께 전송할 수 있습니다.

<h2>제14조 서비스의 변경</h2>① 페이게이트는 안정적인 서비스 제공을 위하여 서비스의 내용, 운영상 또는 기술상 사항 등을 변경할 수 있습니다.
② 페이게이트는 서비스를 변경할 경우 변경 내용과 적용일자를 명시하여 개발자 웹사이트에서 사전 공지합니다.
③ 페이게이트는 무료로 제공되는 서비스의 일부 또는 전부를 페이게이트의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.

<h2>제15조 권리의 귀속</h2>① 서비스에 대한 저작권 및 지적재산권은 페이게이트에 귀속됩니다. 다만, 회원의 게시물 및 회원이 개발하는 프로그램 등은 제외합니다.
② 페이게이트는 서비스와 관련하여 회원에게 페이게이트가 정한 이용조건에 따라 계정, 개발자 웹사이트 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.

<h2>제16조 서비스 이용계약의 해지 및 손해배상</h2>① 회원은 언제든지 개발자 웹사이트에 접속하여 서비스 이용계약의 해지를 신청할 수 있으며, 페이게이트는 법령이 정하는 바에 따라 회원의 해지 신청을 신속히 처리합니다.
② 회원의 해지 처리가 완료되는 경우 페이게이트는 관련 법령 및 개인정보처리방침에 따라 보유하는 회원의 정보를 제외한 회원의 모든 정보를 삭제합니다.
③ 회원의 서비스 이용계약 해지가 완료되는 경우 서비스 운영정책에서 정하는 바에 따라 탈퇴한 회원의 정보로 다시 가입하는 것이 제한 될 수 있습니다.
④ 페이게이트는 회원이 연속하여 6개월 이상 프로그램 등을 통한 서비스 요청을 하지 않는 경우 서비스의 안정성 확보를 위하여 회원에게 별도 고지 후 본 서비스 이용 계약을 해지할 수 있습니다.
⑤ 페이게이트 또는 회원이 본 약관의 규정을 위반함으로 인하여 손해가 발생하게 되는 경우, 본 약관을 위반한 당사자는 다른 당사자에게 발생한 손해를 배상해야 합니다.
⑥ 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 페이게이트가 당해 회원 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 페이게이트를 면책시켜야 하며, 당해 회원은 그로 인하여 페이게이트에게 발생한 모든 손해를 배상해야 합니다.

<h2>제17조 이용제한</h2>① 페이게이트는 회원이 이 약관 및 운영정책에 따른 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 데이터 삭제 요구, 일시정지(플랫폼 기능에 대한 개발자와 앱의 액세스 제한 포함), 이용계약의 해지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.
② 페이게이트는 전항에도 불구하고, 회원이 현행 법령을 위반한 경우에는 즉시 서비스 이용계약을 해지할 수 있습니다.
③ 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우 페이게이트는 제9조에 따라 회원에게 통지합니다.
④ 회원은 본 조에 따른 이용제한 등에 대해 페이게이트가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 페이게이트가 인정하는 경우 페이게이트는 즉시 서비스의 이용을 재개합니다.

<h2>제18조 책임제한</h2>① 페이게이트는 천재지변, 디도스(DDOS) 공격, IDC장애, 기간통신사업자의 회선 장애 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임을 부담하지 않습니다.
② 페이게이트는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 부담하지 않습니다.
③ 페이게이트는 회원이 개발한 서비스의 신뢰도, 정확성, 적법성 등에 대하여 보증하지 않으며, 관련하여 어떠한 책임도 부담하지 않습니다.
④ 페이게이트는 서비스를 통해 회원의 프로그램 등 개발에 부가적인 기능을 제공할 뿐이며, 서비스를 사용에 따른 어떠한 효과 향상도 보증하지 않습니다.
⑤ 페이게이트는 무료로 제공되는 서비스 이용과 관련하여 관련법령에 특별한 규정이 없는 한 책임을 부담하지 않습니다.

<h2>제19조 준거법 및 재판관할</h2>① 페이게이트와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.
② 페이게이트와 회원간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.

<h2>부칙</h2>① 이 약관은 2023년 2월 9일부터 적용됩니다. 단, 본 약관의 공지 시점으로부터 적용일 전일까지 기간 동안에 가입한 신규회원에 대해서는 회원 가입시부터 본 약관이 적용됩니다.
            `)}}>
            </pre>
          </div>
        </div>
        
        {/* <Footer /> */}
      </div>
    </>
  )
}

export default TOS